import { SUBCLUSTERS } from '../subclusters.js';

const INFORMATION_TECHNOLOGY_CLUSTER = {
    subclusters: [
        {
            key: SUBCLUSTERS.TASKS,
        },
        {
            key: SUBCLUSTERS.MANAGING_PROJECTS_PORTFOLIO,
        },
        {
            key: SUBCLUSTERS.RESOURCE_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.REPORTING_TO_EXECUTIVES,
        },
        {
            key: SUBCLUSTERS.KNOWLEDGE_BASE,
        },
        {
            key: SUBCLUSTERS.TICKETS_AND_REQUESTS,
        },
        {
            key: SUBCLUSTERS.IT_SERVICE_DESK,
        },
        {
            key: SUBCLUSTERS.PROJECT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.CRM,
        },
        {
            key: SUBCLUSTERS.SOFTWARE_DEVELOPMENT,
        },
    ],
    mini_site: {
        logo: {
            alt: 'monday.com Service',
            url: '/w/service',
            src: 'https://dapulse-res.cloudinary.com/image/upload/SVC-oneliner-box.svg',
            mobileSrc: 'https://dapulse-res.cloudinary.com/image/upload/SVC-oneliner-box.svg',
        },
        links: [
            {
                url: '/w/service',
                text: 'minisite.header.overview',
            },
            {
                url: '/w/service/partnership-service',
                text: 'minisite.header.partners',
            },
            {
                url: '/service/pricing',
                text: 'minisite.header.pricing',
                isPricingPage: 'true',
            },
        ],
        unifiedDesktopLogo: {
            url: '/service',
            src: 'https://dapulse-res.cloudinary.com/image/upload/SVC-oneliner-box.svg',
            alt: 'monday.com Service',
        },
    },
};

export { INFORMATION_TECHNOLOGY_CLUSTER };
